import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	PetitionReadyToSharePostsQuery,
	PetitionReadyToSharePostsQueryVariables,
} from './getPetitionReadyToSharePosts.graphql';
import { PetitionReadyToSharePosts } from './getPetitionReadyToSharePosts.graphql';

export * from './getPetitionReadyToSharePosts.graphql';

export type ReadyToSharePosts = Extract<
	PetitionReadyToSharePostsQuery['petitionReadyToSharePosts'],
	{ __typename: 'PetitionReadyToSharePosts' }
>;

export async function getPetitionReadyToSharePosts(
	slugOrId: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<ReadyToSharePosts> {
	const { data } = await fetch<PetitionReadyToSharePostsQuery, PetitionReadyToSharePostsQueryVariables>({
		query: PetitionReadyToSharePosts,
		variables: { slugOrId },
		rejectOnError: true,
	});

	if (data.petitionReadyToSharePosts.__typename === 'PetitionReadyToSharePosts') {
		return data.petitionReadyToSharePosts;
	}

	return {
		__typename: 'PetitionReadyToSharePosts',
		totalCount: 0,
		items: [],
	};
}
